/*
 * @Author: Teemo Ding
 * @Date: 2022-03-03 17:05:46
 * @LastEditTime: 2022-03-03 17:07:02
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/components/GeneralInformation/index.tsx
 */
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../../css.module.less';
const GeneralInformation = ({ generalInformationText }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={css.generalInformation}>
      <h3>{getI18n('salesChannelCommunication.index.generalInformation')}</h3>
      <p>{generalInformationText}</p>
    </div>
  );
};

export default GeneralInformation;
